import { yupResolver } from '@hookform/resolvers/yup';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { useCreateVoucherMutation } from '../../../../transactions/hooks/useCreateVoucherMutation';

export interface CreateVoucherInputs {
  code: string;
  amount: number;
}

const schema = yup
  .object({
    code: yup.string().required('Le code du code de réduction est requis'),
    amount: yup.number().required('Le montant du code de réduction est requis'),
  })
  .required();

export const useCreateVoucherDrawer = (
  eventId: string | null,
  onClose: () => void,
) => {
  const { createVoucher } = useCreateVoucherMutation(() => {
    onClose();
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CreateVoucherInputs>({
    resolver: yupResolver(schema),
    defaultValues: {
      code: '',
      amount: 300,
    },
  });

  const onValid: SubmitHandler<CreateVoucherInputs> = async (data) => {
    if (!eventId) {
      return;
    }
    createVoucher({
      amount: data.amount,
      code: data.code,
      eventId,
    });
  };

  const onSubmit = handleSubmit(onValid);

  return {
    onSubmit,
    register,
    errors,
  };
};
